export const createSkeleton = (color: string) =>
  `<article class="Preview">` +
  `<figure class="Preview__figure" style="background: ${color};"></figure>` +
  `<div class="Preview__meta"></div>` +
  `</article>`
